// Sleep for n ms
function sleep(delay, _ref) {
  let {
    signal
  } = _ref;
  if (signal.aborted) {
    return Promise.reject(new DOMException('aborted', 'AbortError'));
  }
  if (delay <= 0) {
    return Promise.resolve('resolved');
  }
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(resolve, delay, 'resolved');
    signal.addEventListener('abort', () => {
      window.clearTimeout(timeout);
      reject(new DOMException('aborted', 'AbortError'));
    });
  });
}

export { sleep as default };
//# sourceMappingURL=sleep.js.map
